import { Menu, Hash, Sun, Moon } from 'lucide-react'
import { useParams } from 'react-router-dom'
import useTheme from '../../hooks/useTheme'

interface MobileHeaderProps {
  onMenuClick: () => void
  onMembersClick?: () => void
}

const channelNames: Record<string, string> = {
  'missoes': 'Missões',
  'arsenal': 'Materiais',
  'materiais': 'Materiais',
  'contatos': 'Contatos',
  'blog': 'Blog',
  'resultados': 'Ranking',
  'dashboard': 'Home',
  'perfil': 'Perfil',
}

export default function MobileHeader({ onMenuClick }: MobileHeaderProps) {
  const { theme, toggleTheme } = useTheme()
  const { channel } = useParams()
  const currentChannel = channel ? channelNames[channel] || channel : 'home'

  return (
    <div className="h-12 px-3 flex items-center gap-2 bg-surface-primary border-b border-border-subtle lg:hidden shrink-0">
      {/* Hamburger */}
      <button
        onClick={onMenuClick}
        className="w-8 h-8 flex items-center justify-center rounded-md text-content-muted hover:text-content-normal hover:bg-surface-hover transition-colors"
      >
        <Menu size={20} />
      </button>

      {/* Channel / Page name */}
      <div className="flex-1 flex items-center gap-1.5 min-w-0">
        <Hash size={14} className="text-content-muted shrink-0" />
        <span className="text-sm font-semibold text-content-normal truncate">
          {currentChannel}
        </span>
      </div>

      {/* Theme toggle */}
      <button
        onClick={toggleTheme}
        className="w-8 h-8 flex items-center justify-center rounded-md text-content-muted hover:text-content-normal hover:bg-surface-hover transition-colors"
      >
        {theme === 'dark' ? <Sun size={18} /> : <Moon size={18} />}
      </button>

      {/* Members — desabilitado por enquanto */}
      {/* <button
        onClick={onMembersClick}
        className="w-8 h-8 flex items-center justify-center rounded-md text-content-muted hover:text-content-normal hover:bg-surface-hover transition-colors"
      >
        <Users size={18} />
      </button> */}
    </div>
  )
}
